<template>
  <transition>
    <div class="newsDetail DivImage" :style="{background: 'url('+ backgroungImg +') no-repeat'}">
      <img src="../../assets/image/logo-light.png" alt="logo" class="logo-dark">
      <info-header :type="'5'"></info-header>
      
      <div class="detail-container">
        <div class="detail-content">
          <div class="article-header">
            <h1 class="article-title" @selectstart.stop @contextmenu.stop>{{ newsDetail.title }}</h1>
            <p class="article-time">{{ newsDetail.createAt }}</p>
          </div>

          <div class="article-cover" v-if="newsDetail.coverUrl">
            <img :src="newsDetail.coverUrl">
          </div>

          <div
            class="article-body"
            v-html="newsDetail.content"
            @selectstart.stop
            @contextmenu.stop
          ></div>

          <div class="back-btn-wrapper">
            <Button type="primary" ghost icon="ios-arrow-back" @click="goBack">Back to News</Button>
          </div>
        </div>
      </div>

      <info-footer :isStatic="true"></info-footer>
    </div>
  </transition>
</template>

<script>
  import InfoHeader from '../../components/infoHeader.vue'
  import InfoFooter from '../../components/infoFooter.vue'

  export default {
    name: 'NewsDetail',
    components: {
      InfoHeader, InfoFooter
    },
    data() {
      return {
        backgroungImg: 'https://cdn.ftgstudio.com/ftg-server/ndata/image/20191019/img-TCPzBEVsiF.jpg',
        newsDetail: {
          title: '',
          createAt: '',
          coverUrl: '',
          content: ``
        }
      }
    },
    mounted() {
      this.getNewsDetail();
    },
    methods: {
      goBack() {
        this.$router.push('/news');
      },
      getNewsDetail() {
        this.$api.getNewsDetail({ newsId: this.$route.query.id }).then(res => {
          if(res.rescode == 0){
            let Data = JSON.parse(JSON.stringify(res))
            Data.content = Data.content.replace(/www.ftgstudio.com/g, 'cdn.ftgstudio.com')
            Data.coverUrl = Data.coverUrl.replace('www.ftgstudio.com', 'cdn.ftgstudio.com')

            this.newsDetail = Data
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../assets/css/main.less';

  .newsDetail {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    background-size: cover !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .detail-container {
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 50px 20px;
    // background: rgba(0, 0, 0, 0.4);
  }

  .detail-content {
    width: 100%;
    max-width: 1200px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 4px;
    padding: 60px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
  }

  .article-header {
    text-align: center;
    margin-bottom: 40px;
  }

  .article-title {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    line-height: 1.3;
  }

  .article-time {
    font-size: 14px;
    color: #999;
    font-family: 'Arial', sans-serif;
  }

  .article-cover {
    width: 100%;
    max-height: 500px;
    overflow: hidden;
    border-radius: 4px;
    margin-bottom: 40px;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .article-body {
    font-size: 16px;
    line-height: 1.8;
    color: #444;
    margin-bottom: 60px;
    /* 防止超长英文单词或链接（如 URL）在窄屏下产生横向溢出 */
    word-wrap: break-word;
    overflow-wrap: break-word;
    /* 在必要时添加连字符，保留完整单词 */
    hyphens: auto;
    /* 防止 img 等元素溢出 */
    max-width: 100%;
    
    p {
      margin-bottom: 20px;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    /* 确保图片不溢出 */
    img {
      max-width: 100%;
      height: auto;
      display: block;
    }

    /* 确保代码块不溢出 */
    code, pre {
      max-width: 100%;
      overflow-x: auto;
      word-break: break-word;
    }

    /* 确保链接不溢出 */
    a {
      word-break: break-word;
    }
  }

  .back-btn-wrapper {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    
    button {
      padding: 10px 30px;
      font-size: 14px;
      letter-spacing: 1px;
      
      &:hover {
        color: #d35d1e;
        border-color: #d35d1e;
      }
    }
  }

  /* Responsive Design */
  @media screen and (max-width: 768px) {
    .detail-content {
      padding: 20px;
    }

    .article-title {
      font-size: 24px;
    }

    .article-body {
      font-size: 15px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/news/detail.vue